<template>
  <div>
    <Heading v-if="rendersAnything" tag="h2">{{ $t('examples.prerequisites') }}</Heading>
    <div class="accordion-wrapper">
      <VAccordion expand-mode="multi">
        <CreateApplication v-if="shouldRenderCreateApplication" :app="langExample.application" />
        <BuyVonageNumber v-if="shouldRenderBuyANumberSection" />
        <LinkVonageNumber v-if="shouldRenderLinkANumberSection" />
        <InstallDependencies v-if="shouldRenderInstallDependencies" :lang-example="langExample" />
        <ImportDependencies v-if="shouldRenderImportDependencies" :lang-example="langExample" />
        <InitializeDependencies
          v-if="shouldRenderInitializeDependencies"
          :lang-example="langExample"
          :has-import-dependencies="shouldRenderImportDependencies"
        />
      </VAccordion>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LanguageExample } from '@bifrost-dev-docs-mfe/common/types/examples';
import { computed, PropType } from 'vue';
import { VAccordion } from '@vonage/vivid-vue';
import Heading from '@/components/example/components/Heading.vue';
import CreateApplication from '@/components/example/prerequisites/CreateApplication.vue';
import InstallDependencies from '@/components/example/prerequisites/InstallDependencies.vue';
import ImportDependencies from '@/components/example/prerequisites/ImportDependencies.vue';
import InitializeDependencies from '@/components/example/prerequisites/InitializeDependencies.vue';
import BuyVonageNumber from '@/components/example/prerequisites/BuyVonageNumber.vue';
import LinkVonageNumber from '@/components/example/prerequisites/LinkVonageNumber.vue';

const props = defineProps({ langExample: { type: Object as PropType<LanguageExample>, required: true } });

const shouldRenderCreateApplication = computed(() => !!props.langExample.application);
const shouldRenderInstallDependencies = computed(() => !!props.langExample.dependencies);
const shouldRenderImportDependencies = computed(() => !!props.langExample.import_dependencies);
const shouldRenderInitializeDependencies = computed(() => !!props.langExample.client);
const rendersAnything = computed(
  () =>
    shouldRenderCreateApplication.value ||
    shouldRenderInstallDependencies.value ||
    shouldRenderImportDependencies.value ||
    shouldRenderInitializeDependencies.value
);
const shouldRenderBuyANumberSection = computed(() => props.langExample.buy_a_vonage_number);
const shouldRenderLinkANumberSection = computed(() => props.langExample.link_a_vonage_number);
</script>
<style scoped lang="scss">
.accordion-wrapper {
  border: 1px solid lightgray;
}
</style>
